<template>
  <div class="animated fadeIn encuesta-usuario">
    <b-row>
      <b-col cols="12">
        <b-card header="Encuesta de Usuario">
          <b-form>
            <b-form-group
              label="Fecha Encuesta"
              label-for="fechaEncuesta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaEncuesta" 
                v-model="fechaEncuesta" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Tipo Encuesta"
              label-for="encuestaUsuarioTipo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="encuestaUsuarioTipo"
                :value="encuestaUsuarioTipo"
                readonly
                type="text"/>
            </b-form-group>

            <b-form-group
              label="Usuario"
              label-for="usuarioReferido"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="usuarioReferido"
                :value="usuarioReferido"
                readonly
                type="text"/>
            </b-form-group>

            <b-form-group
              label="Referencia"
              label-for="referencia"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="referencia"
                :value="referencia"
                readonly
                type="text"/>
            </b-form-group>
            
            <b-form-group
              label="Calificación"
              label-for="calificacion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="calificacion"
                :value="calificacion | numero(2, true)"
                readonly
                type="text"/>
            </b-form-group>
          </b-form>
        </b-card>

        <b-card header="Resultados de la Encuesta" class="mt-3">
          <div v-for="(item, index) in items" :key="index">
            <template v-if="item.tipoConsulta == 1">
              <app-calificacion
                :itemId="item.id"
                :consulta="item.consulta"
                :calificacion="item.calificacion"
                @setCalificacion="setCalificacion(item, $event)">
              </app-calificacion>
            </template>
            <template v-if="item.tipoConsulta == 2">
              <app-item-aprobado
                :itemId="item.id"
                :consulta="item.consulta"
                :itemSelected="item.aprobado"
                @setItemAprobado="setItemAprobado(item, $event)">
              </app-item-aprobado>
            </template>
          </div>
        </b-card>

        <b-card header="Observaciones">
          <b-form>
            <b-form-group>
              <b-form-textarea
                id="observaciones"
                v-model="$v.observaciones.$model" 
                rows="5"
                max-rows="5"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import Calificacion from  './Calificacion.vue';
import ItemAprobado from  './ItemAprobado.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, numeric, maxLength, minValue, maxValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'encuestaUsuario/getField',
  mutationType: 'encuestaUsuario/updateField',
});

export default {
  name: 'EncuestaUsuarioABM',
  components: {
    appCalificacion: Calificacion,
    appItemAprobado: ItemAprobado,
    appABMButton: ABMButtons,
    Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      noValidar: true,

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'fechaEncuesta',
      'encuestaUsuarioTipo',
      'usuarioReferido',
      'referencia',
      'calificacion',
      'observaciones',
      'items',
    ]),
  },  
  created() {
    let encuestaUsuarioId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        encuestaUsuarioId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('encuestaUsuario/inicializar', encuestaUsuarioId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta 5000 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();
        this.$store.dispatch('encuestaUsuario/save')
          .then(() => this.showModalMsj('La información de la encuesta se registró con éxito',
            this.goList, this.goList, 'light'))
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner())
      }
    },
    goList() {
      this.$router.push({ name: 'EncuestasUsuarios' });
    },
    setCalificacion(item, calificacion) {
      let params = {
        itemId: item.id,
        calificacion: calificacion,
      }
      this.$store.dispatch('encuestaUsuario/setCalificacionItem', params);
    },
    setItemAprobado(item, aprobado) {
      let params = {
        itemId: item.id,
        aprobado: aprobado,
      }
      this.$store.dispatch('encuestaUsuario/setCalificacionItem', params);
    },
  },
  validations: {
    observaciones: {
      maxLength: maxLength(5000)
    },
  },
}
</script>
